import { render, staticRenderFns } from "./OtherLabourSideMenu.vue?vue&type=template&id=86611f08"
import script from "./OtherLabourSideMenu.vue?vue&type=script&lang=js"
export * from "./OtherLabourSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports